import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Aiera } from 'aiera-sdk';
import { withGetUser } from 'graphql/user';
import { get } from 'utils';
import { config } from 'configuration';
import { AieraChatUI } from './ui';

export class AieraChat extends PureComponent {
    static displayName = 'AieraChatContainer';

    static propTypes = {
        user: PropTypes.objectOf(PropTypes.any),
        styles: PropTypes.objectOf(PropTypes.any)
    };

    static defaultProps = {
        user: undefined,
        styles: undefined
    };

    constructor(props) {
        super(props);
        this.loadComponent = this.loadComponent.bind(this);
        this.setup = this.setup.bind(this);

        this.state = {
            loaded: false
        };
    }

    componentDidMount() {
        this.setup();
    }

    componentDidUpdate() {
        this.setup();
    }

    componentWillUnmount() {
        clearInterval(this.pollIframe);
    }

    setup() {
        const { user } = this.props;
        const { loaded } = this.state;
        if (!loaded && get(user, 'id')) {
            this.setState({ loaded: true }, () => {
                this.pollIframe = setInterval(() => {
                    const ifr = document.getElementById('aiera-chat-frame');
                    if (ifr) {
                        this.loadComponent();
                        clearInterval(this.pollIframe);
                    }
                }, 100);
            });
        }
    }

    loadComponent() {
        const { user } = this.props;
        const apiKey = get(user, 'apiKeyPublic', config.PUBLIC_API_KEY);
        this.aieraChat = new Aiera.Module(
            `${config.PUBLIC_API_ENDPOINT}modules/AieraChat/index.html`,
            'aiera-chat-frame'
        );
        this.aieraChat.load().then(() => {
            this.aieraChat.authenticateApiKey(apiKey);
        });
        this.aieraChat.on('authenticated', () => {
            this.aieraChat.configure({
                hideSettings: true,
                options: {
                    aieraChatEnableAbly: true,
                    aieraChatEnablePolling: false,
                    aieraChatCollectInternalFeedback: true,
                    showSearch: true,
                    showSentiment: false,
                    darkMode: false
                },
                tracking: {
                    userId: get(user, 'id', 'login-with-public-api-key-1') // Use the current userId value
                }
            });
        });
    }

    render() {
        const { styles } = this.props;
        return <AieraChatUI styles={styles} />;
    }
}

export const AieraChatContainer = compose(
    withGetUser({
        fetchPolicy: 'cache-first',
        variables: { withDetails: true, withDev: true, withOrganization: true }
    })
)(AieraChat);
